import * as ApiCons from "@/api/http/ins/insConst";
import Http from "@/api/http/fetch";
import * as InsRequest from "@/api/http/ins/insBase";
import CookieManager from "@/api/http/ins/insCookieManager";
import { getUUid, signBody } from "@/api/http/utils/apiHelpers";
import store from "@/store";
import * as types from "@/store/constants/types";
import { sendIGError, sendIGSuccess } from "@/utils/analytics";

export const postMediaEnableComments = (mediaId: any, userId: any) =>
  new Promise(async (resolve, reject) => {
    if (!mediaId) {
      reject(new Error("mediaId can not be empty"));
    }
    try {
      const info = {
        _uuid: await getUUid(),
        _csrftoken: await store.getters[types.GETTER_CROS_TOKEN_BY_USER_ID](
          userId
        )
      };
      const extra = {
        userId,
        handleErr: false,
        fromWorker: false
      };
      const data = await signBody(info);
      const result = await InsRequest.post(
        ApiCons.postMediaEnableCommentsUrl(mediaId),
        {
          data
        },
        extra
      );
      sendIGSuccess("postMediaEnableComments");
      resolve(result);
    } catch (error) {
      sendIGError(error, "postMediaEnableComments");
      reject(error);
    }
  });
